import { useMemo } from 'react';

import { useIntl } from 'react-intl';

import { Allergens } from 'components/nutrition/allergens';
import { TableHeader } from 'components/nutrition/v2/table-header';
import { AllergenIncludes } from 'enums/menu';
import { ILocalizedMenuEntry } from 'state/unified-menu/types';

type ItemAllergensProps = {
  item: ILocalizedMenuEntry;
};

export const ItemAllergens = ({ item }: ItemAllergensProps) => {
  const { formatMessage } = useIntl();

  const allergenGroups = useMemo(() => {
    const groupsMap = new Map<AllergenIncludes, string[]>();

    Object.entries(item.nutrition?.allergens || {})
      .filter(([key, value]) => key !== '__typename' && value !== null && value !== '_0')
      .forEach(([key, value]) => {
        const includes = Number((value as string).replace('_', '')) as AllergenIncludes;
        if (!groupsMap.has(includes)) {
          groupsMap.set(includes, []);
        }
        groupsMap.get(includes)!.push(key);
      });

    return Array.from(groupsMap.entries()).map(([allergenIncludes, allergenNames]) => ({
      allergenIncludes,
      allergenNames,
    }));
  }, [item]);

  if (!allergenGroups.length) {
    return null;
  }

  return (
    <>
      <TableHeader testID="allergens-header" title={formatMessage({ id: 'allergenInformation' })} />
      <Allergens allergenGroups={allergenGroups} />
    </>
  );
};
